module.exports = __webpack_public_path__ + "static/media/wallet-statement.7253f77a.svg";